import { useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import MailIcon from '../../../assets/icons/mail.svg'
import { confirmResetPassword, resetPassword } from 'aws-amplify/auth'
import { equalTo, messages } from '../../../utils/validationErrorMessages'
import { compileTemplate } from '../../../utils'
import { createToast } from '../../../utils/Toast'
import FormInput from '../../atoms/Input/Form-Input'
import Button from '../../atoms/Buttons'

const Toast = createToast()

const ForgotPasswordForm = () => {
  const methods = useForm()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [forgetPasswordCodeSent, setForgetPasswordCodeSent] = useState(false)

  const onHandleForgotPassword = async data => {
    setLoading(true)
    try {
      if (forgetPasswordCodeSent) {
        await confirmResetPassword({
          username: email,
          confirmationCode: data.code,
          newPassword: data.newPassword,
        })

        Toast.fire({
          icon: 'success',
          title: 'Password Reset Successfully',
        })

        navigate('/')
      } else {
        setEmail(data.email)
        const response = await resetPassword({ username: data.email })
        if (
          response?.nextStep?.resetPasswordStep ===
          'CONFIRM_RESET_PASSWORD_WITH_CODE'
        ) {
          setForgetPasswordCodeSent(true)
        } else if (response?.nextStep?.resetPasswordStep === 'DONE') {
          Toast.fire({
            icon: 'success',
            title: 'Successfully reset password.',
          })
        }
      }
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: error.message?.toString() || 'Undefined error',
      })
    } finally {
      setLoading(false)
    }
  }

  const renderForm = () => (
    <div className="w-full h-screen flex justify-center items-center bg-[#F7F7F6]">
      <div className="register-modal-content w-[90%] sm:w-[545px] h-auto md:h-[420px] bg-[#fff] rounded-xl my-auto">
        <h3 className="saddlefit-admin-forgotpassword">Forgot password?</h3>

        <div className="register-content">
          <div className="register-content-form w-[90%] mx-auto">
            <FormInput
              name="email"
              label="Email"
              icon={MailIcon}
              validations={{
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: 'Invalid email address',
                },
              }}
              placeholder="example@example.com"
            />
          </div>
          <div className="register-content-submit">
            <div className="flex justify-center items-center">
              <Button
                type="submit"
                className="modal_form_btn cursor-pointer"
                primary
                loading={loading}
              >
                Send Code
              </Button>
            </div>
          </div>
          <div className="register-content-links w-[90%] mb-5 md:mb-0 mx-auto">
            <Link className="text-secondary" to="/">
              Terms of service
            </Link>
            <Link className="text-secondary" to="/">
              Privacy policy
            </Link>
            <Link className="text-secondary" to="/">
              Contact us
            </Link>
          </div>
        </div>
      </div>
    </div>
  )

  const renderPasswordResetForm = () => (
    <div className="w-full h-screen flex justify-center items-center bg-[#F7F7F6]">
      <div className="w-[500px] bg-[#fff] rounded-xl">
        <h3 className="saddlefit-admin-forgotpassword">Forgot password?</h3>

        <div className="register-content-form w-[90%] mx-auto">
          <FormInput
            name="code"
            label="Code"
            placeholder="Enter code"
            validations={{
              required: "Code is required"
            }}
          />

          <FormInput
            type="password"
            name="newPassword"
            label="New Password"
            placeholder="Enter password"
            validations={{
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters"
              },
              maxLength: {
                value: 20,
                message: "Password cannot be longer than 20 characters"
              },
              required: "Password is required"
            }}
            className="mt-5"
          />

          <FormInput
            type="password"
            label="Repeat password"
            className="mt-5"
            validations={{
              equalTo: equalTo(
                'newPassword',
                compileTemplate(messages.equalTo, { attribute: 'newPassword' }),
              ),
              required: "Please confirm your password"
            }}
            name="repeat_password"
            placeholder="Repeat password"
          />
        </div>
        <div className="register-content-submit flex justify-center items-center mb-5">
          <Button
            type="submit"
            className="modal_form_btn"
            primary
            loading={loading}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  )

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onHandleForgotPassword)}>
          {!forgetPasswordCodeSent ? renderForm() : renderPasswordResetForm()}
        </form>
      </FormProvider>
    </>
  )
}

export default ForgotPasswordForm
